:host {
  --aha-tags--spacing: var(--spacer-1);

  display: flex;
  flex-direction: row;
  gap: var(--aha-tags--spacing);
  flex-wrap: wrap;
}
